import { autoWebViewJs } from "../../AutoWebViewJs"
import { askPanelFunction, IPermissionAskResult, IPermissionResult, PermissionAskStatus, askPermissionsBack } from "./permissions.intf";
import { Log } from "@fanfanlo";
const fileLog = new Log(false, 'permissionUtils');
function checkPermissions(permissions:string[]):IPermissionAskResult{
    const fnLog = fileLog.sub(false, 'checkPermissions_fn')
    const script = `
    com.fanfanlo.lib.permission.PermissionRequestManager.checkPermissions(${JSON.stringify(permissions)});
    `
    const {javaResultData, javaResultString, errMsg} = autoWebViewJs.callScript<IPermissionResult>(script);
    fnLog.info('checkPermissions_fn javaResultData=', javaResultData, 'javaResultString=', javaResultString, 'errMsg=', errMsg)
    const result:IPermissionAskResult = {
        isGranted:javaResultData?.isAllGranted || false,
        status:javaResultData?.isAllGranted ? PermissionAskStatus.granted : PermissionAskStatus.asking,
        permissionResult:javaResultData
    }
    return result;
}

function ask(checkResult:IPermissionAskResult, permissions:string[], completeEventName:string, askPermissionsBack:askPermissionsBack ){
    const fnLog = fileLog.sub(false, 'ask_fn')
    const script = `
    com.fanfanlo.lib.permission.PermissionRequestManager.requestMultiplePermissions(${JSON.stringify(permissions)}, "${completeEventName}");
    `;
    fnLog.info('script=', script)
    autoWebViewJs.callScript(script);
    function onEvent(){
        fnLog.info('onEvent_fn')
        const checkResult = checkPermissions(permissions)
        askPermissionsBack(false, checkResult.isGranted, checkResult);
    }
    window.addEventListener(completeEventName, onEvent);
    function unsubListener (){
        fnLog.info('unsubListener_fn')
        window.removeEventListener(completeEventName, onEvent);
    }
    checkResult.unsubListener = unsubListener;
}
function askPermissions(permissions:string[], completeEventName:string, askPermissionsBack:askPermissionsBack, askPanelFunction? :askPanelFunction):IPermissionAskResult{
    const fnLog = fileLog.sub(false, "askPermission_fn")
    const checkResult = checkPermissions(permissions)
    fnLog.info('askPermission_fn checkResult=', checkResult)
    if(checkResult.isGranted){
        fnLog.info("askPermission_fn checkResult.isGranted")
        return checkResult;
    }
    fnLog.info('askPermission_fn askPanelFunction=', !!askPanelFunction)
    if(askPanelFunction){
        if(!checkResult.permissionResult){
            fnLog.error('askPermission_fn checkResult.permissionResult is null');
            throw new Error('checkResult.permissionResult is null');
        }
        askPanelFunction(checkResult.permissionResult!, (toAsk)=>{
            fnLog.info("askPermissions_fn askPanelFunction toAsk=", toAsk)
            if(toAsk){
                ask(checkResult, permissions, completeEventName, askPermissionsBack);
            }else{
                askPermissionsBack(true, false)
            }
        })
    }else{
        ask(checkResult, permissions, completeEventName, askPermissionsBack);
    }
    return checkResult
}
export const permissionUtils = {
    askPermissions,
}